export default __webpack_public_path__ + "static/media/powered-img.97e0cda6.png";